module.exports = __webpack_public_path__ + "static/img/case_logo_03.58c8f56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_logo_03.png
// module id = Ox/7
// module chunks = 34